import * as THREE from 'three'
import Experience from '../Experience'

import particlesFragment from '../../../../static/shaders/particlesFragment.glsl'
import particlesVertex from '../../../../static/shaders/particlesVertex.glsl'

export default class Particles {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.time = this.experience.time

    //Method
    this.generateParticles()
  }
  generateParticles() {
    this.particlesGeometry = new THREE.BufferGeometry()
    this.particlesCount = 150
    this.particlesPositions = new Float32Array(this.particlesCount * 3)
    this.particlesScale = new Float32Array(this.particlesCount)
    for (let i = 0; i < this.particlesCount; i++) {
      this.particlesPositions[i * 3 + 0] = (Math.random() - 0.5) * 30
      this.particlesPositions[i * 3 + 1] = Math.random() * 0.2 * 12
      this.particlesPositions[i * 3 + 2] = (Math.random() - 1) * -5

      this.particlesScale[i] = Math.random(0.5, 1)
    }

    this.particlesGeometry.setAttribute('position', new THREE.BufferAttribute(this.particlesPositions, 3))
    this.particlesGeometry.setAttribute('uScale', new THREE.BufferAttribute(this.particlesScale, 1))

    this.particlesMaterial = new THREE.ShaderMaterial({
      uniforms: {
        uTime: {
          value: 0,
        },
        uSize: {
          value: 300,
        },
        uPixelRatio: {
          value: Math.min(window.devicePixelRatio, 2),
        },
      },
      fragmentShader: particlesFragment,
      vertexShader: particlesVertex,
      transparent: true,
      blending: THREE.AdditiveBlending,
      depthWrite: false,
    })
    this.particles = new THREE.Points(this.particlesGeometry, this.particlesMaterial)
    this.scene.add(this.particles)
  }
  update() {
    this.particlesMaterial.uniforms.uTime.value = this.time.elpasedTime * 0.5
  }
}
